import { useEffect } from "react";

/**
 * Loads the real AI conversation bot (widget ID 6a7ca1618ce6e21783c97af6)
 * that books junk pickup appointments directly into the CRM.
 * 
 * PERFORMANCE: Uses IntersectionObserver to delay load until widget is near viewport,
 * and loads script with async + defer to avoid blocking main thread.
 */
export const ChatWidget: React.FC = () => {
  useEffect(() => {
    // Avoid duplicate injection on re-renders / HMR
    if (document.getElementById("lc-chat-widget-loader")) return;

    let observer: IntersectionObserver | null = null;
    let script: HTMLScriptElement | null = null;

    const initWidget = () => {
      if (document.getElementById("lc-chat-widget-loader")) return;
      
      script = document.createElement("script");
      script.id = "lc-chat-widget-loader";
      script.src = "https://widgets.leadconnectorhq.com/loader.js";
      script.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
      script.setAttribute("data-widget-id", "6a7ca1618ce6e21783c97af6");
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
    };

    // Delay widget load until 10s idle or upon user interaction
    const timer = setTimeout(initWidget, 10000);

    const handleInteraction = () => {
      clearTimeout(timer);
      initWidget();
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
    };

    window.addEventListener("scroll", handleInteraction, { passive: true });
    window.addEventListener("touchstart", handleInteraction, { passive: true });
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
      observer?.disconnect();
      if (script && script.parentNode) {
        script.remove();
      }
    };
  }, []);

  // The widget injects its own floating button + chat window into the DOM.
  return null;
};
